import ApplicationController from "./application_controller";

export default class extends ApplicationController {

  connect() {
    this.element.addEventListener("ajax:beforeSend", function(event) {
      const detail = event.detail, xhr = detail[0], options = detail[1]

      Turbo.visit(options.url, { action: "replace" })
      event.preventDefault()
    })
  }

}
